import React, { ReactNode } from "react";
import * as palette from "@govlaunch/palette";
import { Logo } from "./icons";
import useIsPhone from "../../lib/hooks/useIsPhone";
import Container from "./Container";
import { getGovlaunchUrl } from "../utils/getGovlaunchUrl";

const Footer: React.FunctionComponent = () => {
  const isPhone = useIsPhone();

  return (
    <div
      css={{
        borderTop: `solid 1px ${palette.lightestGray}`,
        backgroundColor: palette.white,
        marginTop: "auto"
      }}
    >
      <Container>
        <div
          css={{
            display: "flex",
            justifyContent: isPhone ? "center" : "space-between",
            alignItems: "center",
            padding: "32px 0"
          }}
        >
          {!isPhone && <PoweredBy />}

          <div
            css={{
              display: "grid",
              alignItems: "center",
              gridAutoFlow: "column",
              gridColumnGap: 28
            }}
          >
            <Link href={getGovlaunchUrl() || ""}>Visit</Link>

            <Link href="https://docs.govlaunch.com/">About</Link>

            <Link href="https://www.iubenda.com/privacy-policy/8224354">Privacy</Link>
          </div>
        </div>
      </Container>
    </div>
  );
};

interface ILinkProps {
  href: string;
  children: ReactNode;
}

const Link = ({ href, children }: ILinkProps) => {
  return (
    <a
      href={href}
      target="blank"
      rel="noopener noreferrer"
      css={{
        textDecoration: "none",
        color: palette.sealBlue,
        fontSize: 14,
        "&:hover": {
          textDecoration: "underline"
        }
      }}
    >
      {children}
    </a>
  );
};

const PoweredBy = () => (
  <div
    css={{
      border: `1px solid ${palette.lightestGray}`,
      borderRadius: 5,
      display: "flex",
      padding: 12,
      alignItems: "center"
    }}
  >
    <Logo size={30} color={palette.mediumGray} />

    <div
      css={{
        fontSize: 12,
        marginLeft: 16,
        color: palette.darkGray
      }}
    >
      <p
        css={{
          marginBottom: 3
        }}
      >
        Powered by <strong>Govlaunch</strong>
      </p>

      <p>
        Have an account?{" "}
        <a
          href={`${getGovlaunchUrl()}/signin`}
          target="_blank"
          rel="noopener noreferrer"
          css={{
            color: palette.darkGray,
            textDecoration: "underline"
          }}
        >
          Sign in
        </a>
      </p>
    </div>
  </div>
);

export default Footer;
